import React from 'react';
import { Calendar } from '@/components/ui/calendar';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

function getMonthStart(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export default function MonthCalendarCard({
  title,
  subtitle,
  selectedMonth,
  onMonthChange,
  accentClassName = 'from-primary/10 via-white to-primary/5'
}) {
  const monthLabel = selectedMonth.toLocaleDateString('en-IN', {
    month: 'long',
    year: 'numeric'
  });

  const handlePrevMonth = () => {
    onMonthChange(new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    onMonthChange(new Date(selectedMonth.getFullYear(), selectedMonth.getMonth() + 1, 1));
  };

  const handleSelect = (date) => {
    if (!date) return;
    onMonthChange(getMonthStart(date));
  };

  return (
    <div className={`rounded-2xl border border-slate-200 bg-gradient-to-br ${accentClassName} p-4 shadow-sm`}>
      <div className="flex items-start justify-between gap-4 mb-4">
        <div>
          <h3 className="text-lg font-bold text-slate-900">{title}</h3>
          <p className="text-sm text-slate-500">{subtitle}</p>
        </div>
        <div className="rounded-full bg-white px-3 py-1 text-sm font-semibold text-slate-700 shadow-sm">
          {monthLabel}
        </div>
      </div>

      <div className="flex items-center justify-between gap-3 mb-3">
        <Button type="button" variant="outline" size="sm" onClick={handlePrevMonth} className="rounded-full">
          <ChevronLeft className="w-4 h-4 mr-1" />
          Prev
        </Button>
        <Button type="button" variant="outline" size="sm" onClick={handleNextMonth} className="rounded-full">
          Next
          <ChevronRight className="w-4 h-4 ml-1" />
        </Button>
      </div>

      <div className="rounded-xl bg-white/90 border border-slate-200">
        <Calendar
          mode="single"
          month={selectedMonth}
          selected={selectedMonth}
          onSelect={handleSelect}
          onMonthChange={handleSelect}
          className="w-full"
        />
      </div>
    </div>
  );
}
